module.exports = __webpack_public_path__ + "static/media/MayanPalace.c7b1f147.png";